<template>
  <div id="container">
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <!-- Carga el compononte para activar modal de  ver calendario -->
    <component
      :is="componentCalendar"
      :datos="paramsTareas"
      @closeCalendar="closeModalCalendar"
    ></component>

    <!----- modal  reporte  ------>

    <!-- boton crear -->
    <v-row class="pt-0">

        <v-tooltip  color="#1b1b1b">
          <template v-slot:activator="{ on }">
            <v-btn text small v-on="on" icon color="blue" @click="resetearFiltros()" class="ml-5">
              <v-icon>fa-sync-alt</v-icon>
            </v-btn>
          </template>
          <span>Restablecer filtros </span>
        </v-tooltip>

      <v-col class="d-flex justify-end pt-0">
        <v-col cols="auto pt-0 pr-0">
          <!-- <v-btn class="btn_block_style2" dark  @click="reporte(ActividadesFamilia)" v-if="botonReporte" >REPORTE</v-btn>-->
        </v-col>

        <v-col cols="auto pt-0 pr-0">
          <v-btn
            class="btn_block_style2"
            dark
            @click="verCalendario"
            v-if="botonCalendario"
          >
            <v-icon class="mr-3"> fas fa-calendar-alt </v-icon>
            VER CALENDARIO
          </v-btn>
        </v-col>
      </v-col>
    </v-row>
    <!-- fin de boton -->

    <v-row>
      <v-col></v-col>
      <v-col></v-col>
      <v-col></v-col>
      <v-col>
        <!--<div class="card-alumnos">
                    <div class="title-alumnos"><h5>Alumnos</h5></div>
                    <div v-if="AlumnosFam.length>0">
                         <div class="alumno" v-for="item of AlumnosFam" :key="item.id" >
                            <span><v-icon color="primary">far fa-user</v-icon> <p class="nombre_alumno" style="display:inline;margin-left:15px;"> {{item.nombre_completo}}</p></span>  
                         </div>
                    </div>
                    <div class="sin-alumnos" v-else>
                        <p>No posee alumnos registrados...</p>
                    </div>
                </div>-->
      </v-col>
    </v-row>

    <!-- /////////////////////////////////////////////////////
            //    PANTALLA PRINCIPAL DE PROGRAMACION DOCENTE   //
        ///////////////////////////////////////////////////////////    -->
    <v-card class="pt-3">
      <v-row class="mx-1">
        <v-col cols="12" sm="3" md="" class="py-0">
          <v-autocomplete
            label="Estudiante"
            :items="AlumnosFam"
            autocomplete="off"
            v-model="alumno"
            item-value="id_alumno"
            item-text="persona.nombre_completo"
            @change="getAllAreasFamilia(alumno)"
            return-object
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" sm="3" md="" class="py-0">
          <div class="nivel">
            <p>Nivel</p>
            <span>{{ NivelAlumno }}</span>
          </div>
        </v-col>
        <v-col cols="12" sm="3" md="" class="py-0">
          <div class="grado">
            <p>Grado</p>
            <span>{{ GradoAlumno }}</span>
          </div>
        </v-col>
        <v-col cols="12" sm="3" md="" class="py-0">
          <div class="seccion">
            <p>Sección</p>
            <span> {{ SeccionAlumno }}</span>
          </div>
        </v-col>

        <v-col cols="12" sm="3" md="" class="py-0">
          <v-autocomplete
            label="Área"
            :items="AreaFam"
            :disabled="inhabilitarAreaFam"
            autocomplete="off"
            item-value="id"
            item-text="desc_area"
            dense
            v-model="NivelA"
            @change="getAllActividades(), getAllCursosFamilia(NivelA)"
            return-object
          >
          </v-autocomplete>
        </v-col>

        <v-col cols="12" sm="3" md="" class="py-0">
          <v-autocomplete
            label="Curso"
            :items="CursoFam"
            :disabled="inhabilitarCursoFam"
            autocomplete="off"
            item-value="id_curso"
            item-text="desc_curso"
            dense
            v-model="paramsTareas.id_curso"
            @change="getAllActividades('curso')"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" sm="3" md="" class="py-0">
          <v-autocomplete
            label="Periodo"
            v-model="elrango"
            :items="PeriodoFam"
            autocomplete="off"
            item-value="rango"
            item-text="nombre_periodo"
            dense
            :disabled="inhabilitarPeriodo"
            @change="obtenerRangos()"
          >
          </v-autocomplete>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="ActividadesFamilia"
        :search="search"
        class="elevation-1 black--text"
        fixed-header
      >
        <!-- ESTA ES LA ACTIVIDAD QUE EL DOCENTE LE ASIGNO AL ESTUDIANTE -->
        <template v-slot:item.tareaAsignada="{ item }">
          <v-chip class="primary">
            <a
              @click="download(URL_SPACE + '/' + item.ruta_actividad)"
              style="text-decoration: none; color: #fff"
              >{{ item.archivo_actividad }}</a
            >
          </v-chip>
        </template>
        <template v-slot:item.fechaTope="{ item }">
          <span>{{ item.fecha_actividad | fechaTransform }}</span>
        </template>
        <template v-slot:item.calificacion="{ item }">
          <span v-if="item.calificacion_revision === null">Sin calificar</span>
          <span v-else>{{ item.calificacion_revision }}</span>
        </template>
        <template v-slot:item.comentarioDoc="{ item }">
          <v-menu absolute offset-y style="max-width: 600px">
            <template v-slot:activator="{ on }">
              <v-row justify="space-around" v-on="on">
                <span v-if="item.observacion_actividad === ''"
                  ><v-chip color="error">Sin comentario</v-chip></span
                >
                <v-btn text v-else
                  ><v-icon color="primary">fa-comment-dots</v-icon></v-btn
                >
              </v-row>
            </template>
            <v-card max-width="250px" class="py-2 px-2">
              <v-tooltip bottom color="#1b1b1b">
                <template v-slot:activator="{ on }">
                  {{ item.observacion_actividad }}
                </template>
              </v-tooltip>
            </v-card>
          </v-menu>
        </template>

        <template v-slot:item.estado="{ item }">
          <v-chip
            :style="{ background: item.color_estado_docente, color: '#fff' }"
            >{{ item.desc_estado_docente }}</v-chip
          >
        </template>
        <!-- ESTA ES LA ACTIVIDAD RESUELTA MANDADA POR EL ESTUDIANTE -->
        <template v-slot:item.tareaEnviada="{ item }">
          <v-chip v-if="item.archivo_alumno === null">Sin enviar</v-chip>
          <v-chip class="primary" v-else>
            <a
              @click="download(URL_SPACE + '/' + item.ruta_alumno)"
              style="color: #fff; text-decoration: none"
              >{{ item.archivo_alumno }}</a
            >
          </v-chip>
        </template>
        <template v-slot:item.fechaEnviada="{ item }">
          <span v-if="item.fecha_alumno === null">---</span>
          <span v-else>{{ item.fecha_alumno | fecha }}</span>
        </template>
        <template v-slot:item.estado_alumno="{ item }">
          <v-chip
            :style="{ background: item.color_estado_alumno, color: '#fff' }"
            >{{ item.desc_estado_alumno }}</v-chip
          >
        </template>

        <template v-slot:item.comentarioAlum="{ item }">
          <v-menu absolute offset-y style="max-width: 600px">
            <template v-slot:activator="{ on }">
              <v-row justify="space-around" v-on="on">
                <span v-if="item.observacion_revision === null"
                  ><v-chip color="error">Sin comentario</v-chip></span
                >
                <v-btn text v-else
                  ><v-icon color="primary">fa-comment-dots</v-icon></v-btn
                >
              </v-row>
            </template>
            <v-card max-width="250px" class="py-2 px-2">
              <v-tooltip bottom color="#1b1b1b">
                <template v-slot:activator="{ on }">
                  {{ item.observacion_revision }}
                </template>
              </v-tooltip>
            </v-card>
          </v-menu>
        </template>

        <template v-slot:item.clase="{ item }">
          <v-btn text @click="visualizarClase(item.id_clase)"
            ><v-icon color="success">fa-eye</v-icon></v-btn
          >
        </template>

        <template v-slot:item.claseVirtual="{ item }">
          <v-btn text v-if="item.clase_virtual === 0" disabled
            ><v-icon>fa-video-slash</v-icon></v-btn
          >
          <v-btn
            text
            v-else
            color="teal lighten-1"
            :href="item.enlace_virtual"
            target="_blank"
            ><v-icon>fa-video</v-icon></v-btn
          >
        </template>
        <template v-slot:item.claseGrabada="{ item }">
          <v-btn text v-if="item.clase_virtual_video === 0" disabled
            ><v-icon>fa-video-slash</v-icon></v-btn
          >
          <v-btn
            text
            v-else
            :href="item.clase_virtual_video_enlace"
            target="_blank"
            ><v-icon color="error">fa-play</v-icon></v-btn
          >
        </template>
      </v-data-table>
      <span class="mx-2"
        ><v-chip class="mt-2 mb-2 primary"
          >RECIBIDAS: {{ contProgramada }}</v-chip
        ></span
      >
      <span class="mx-2"
        ><v-chip class="mt-2 mb-2 info"
          >CREADAS: {{ contEjecutada }}</v-chip
        ></span
      >
      <span class="mx-2"
        ><v-chip class="mt-2 mb-2 warning"
          >POR EVALUAR: {{ contSinejecutar }}</v-chip
        ></span
      >
      <span class="mx-2"
        ><v-chip class="mt-2 mb-2 deep-purple darken-1" style="color: #fff"
          >EVALUADAS: {{ contReprogramada }}</v-chip
        ></span
      >
      <span class="mx-2">
        <v-chip class="mt-2 mb-2 success"
          >TOTAL: {{ ActividadesFamilia.length }}</v-chip
        ></span
      >
    </v-card>
    <!--------   pantalla principal   ------>

    <!-- MODAL VISOR DE CONTENIDOS-->
    <v-dialog v-model="visor" scrollable max-width="80%">
      <v-card>
        <v-card-title class="btn_otro">
          <v-row class="d-flex justify-space-between py-0">
            Contenido
            <v-btn fab dark x-small class="btn_style3" @click="cerrarVisor"
              ><v-icon dark>fa-times</v-icon></v-btn
            >
          </v-row>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="text-center">
          <component
            :is="tipoVisor"
            :diapositivas="api_list_contenidos"
          ></component>
          <!-- <ModalVisorCk1 :diapositivas="api_list_contenidos" ></ModalVisorCk1> -->
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios, { API_URL, BUCKET_ORIGIN_SPACE } from "../../../helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import Calendario from "./components/calendarioActividadesFamilia.vue";

export default {
  name: "clasesFamilia",

  components: {
    Calendario,
    // ModalVisorCk1,
    //ModalVisorColegio
  },

  data: (vm) => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 26, id_modulo: 7 }, //sud_modulo y modulo

    datoLogin: sessionStorage, // variables de sesion del usuario
    ruta_api: API_URL, // ruta del servidor
    URL_SPACE: BUCKET_ORIGIN_SPACE,
    ////////////////////////////////////////////////////////

    //validaciones de formulario
    rul: {
      required: (value) => !!value || "Campo Requerido",
      inputReq: (value) => !!value || "Campo Requerido",
      selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo Electrónico es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max40: (v) => (v || "").length <= 40 || "Máximo 40 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",

      email_null: (value) => {
        if (value == "") {
          return false;
        } else {
          const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
          return pattern.test(value) || "El correo electrónico es incorrecto";
        }
      },
    },

    // consulta principal

    // variable iniciales
    inhabilitarAreaFam: true,
    inhabilitarCursoFam: true,
    inhabilitarPeriodo: true,

    search: "",
    ///////////NUEVAS VARIABLES ////////////

    headers: [
      { text: "TEMA", value: "nombre_clase", class: "secondary black--text" },
      {
        text: "ACTIVIDAD ASIGNADA",
        value: "tareaAsignada",
        class: "secondary black--text",
      },
      {
        text: "CALIFICACIÓN",
        value: "calificacion",
        align: "center",
        class: "secondary black--text",
      },
      {
        text: "FECHA  DE ENTREGA",
        value: "fechaTope",
        class: "secondary black--text",
      },
      {
        text: "OBJETIVO DE LA ACTIVIDAD",
        value: "comentarioDoc",
        class: "secondary black--text",
      },
      // { text: 'CALIFICACIÓN ', value: 'calificacion', sortable: false,  class:'secondary black--text'},
      {
        text: "ESTADO",
        value: "estado",
        sortable: false,
        class: "secondary black--text",
      },
      {
        text: "ACTIVIDAD ENVIADA",
        value: "tareaEnviada",
        sortable: false,
        align: "center",
        class: "info black--text",
      },
      {
        text: "FECHA DE ENVÍO",
        value: "fechaEnviada",
        sortable: false,
        align: "center",
        class: "info black--text px-0 mx-0",
      },
      {
        text: "ESTADO DE LA ACTIVIDAD",
        value: "estado_alumno",
        sortable: false,
        align: "center",
        class: "info black--text",
      },
      {
        text: "OBSERVACIONES DE LA ACTIVIDAD",
        value: "comentarioAlum",
        sortable: false,
        align: "center",
        class: "info black--text",
      },

      //{ text: '', value: 'action', sortable: false, align:'center', class:'secondary black--text px-0 mx-0', width:'50'},
    ],

    NivelFam: [],
    GradoFam: [],
    SeccionFam: [],
    AlumnosFam: [],
    AreaFam: [],
    CursoFam: [],
    PeriodoFam: [],
    elrango: "",
    alumno: null,
    Alumno: [],
    NivelA: [],
    NivelAlumno: "",
    GradoAlumno: "",
    SeccionAlumno: "",

    ActividadesFamilia: [],

    componentCalendar: "",
    modal_reporte: false,
    contProgramada: 0,
    contReprogramada: 0,
    contSinejecutar: 0,
    contEjecutada: 0,
    contActualizada: 0,

    botonCalendario: false,
    botonReporte: false,

    paramsTareas: {
      id_colegio: sessionStorage.id_colegio,
      id_ano_lectivo: sessionStorage.id_ano_lectivo,
      id_area: null,
      id_curso: null,
      id_alumno: null,
      fecha_inicio: null,
      fecha_fin: null,
    },

    /////////////////////////////////////

    // modal asociar clase
    modal_asociarClase: false,
    formTitle: "",
    asociarCl: [], // asociar Clases
    search_asociarCl: "",

    //- ck1
    tablaCk1: true,
    clases: [],

    //- colegio
    tablaColegio: false,
    clasesColegio: [],

    nivelCont: [],
    id_nivelFiltro: "",

    gradoCont: [],
    id_gradoFiltro: [],

    gradoContFilter: [],

    areaCont: [],
    areaContFilter: [],
    id_areaFiltro: [],

    cursoCont: [],
    cursoContFilter: [],
    id_cursoFiltro: [],
    ////////////////////////////////////////

    // modal visor de contenidos
    visor: false,
    api_list_contenidos: [],
    tipoVisor: "",
    ///////////////////////////

    //-- funciones del date picker de fecha
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu2: false,
    menu3: false,
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),

    computedDateFormatted2() {
      return this.formatDate(this.programarCl.fecha);
    },
  },
  filters: {
    fechaTransform: function (string) {
      return string.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3/$2/$1");
    },
    fecha: function (string) {
      var cadena1 = string.slice(0, -14);
      var cadena2 = cadena1.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3/$2/$1");
      return cadena2;
    },
  },

  mounted() {
    //this.listarTemas();
    //this.loadMain()
    //this.getAllProfesores()
    this.getAllAlumnosFamilia();
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },
    ////////////////////////////////////////////////////////

    //// modal calendario
    ...mapMutations("progDocente", ["setActivarCalendario"]),

    //  ------- input tipo fecha  --------
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    // componente de  calendario
    verCalendario() {
      // console.log('activando calendario')
      this.setActivarCalendario({ periodo: "", id_docente: "" });
      this.componentCalendar = "Calendario";
    },
    /*****metodo para cerrar calendario *****/
    closeModalCalendar() {
      this.componentCalendar = "";
    },
    ///////////////////////////////////////////////////////////////////////////////
    ////   NUEVAS  FUNCIONES PARA CLASES COORDINACIONES           /////////////////
    //////////////////////////////////////////////////////////////////////////////
    /*********Cargar Hijos de Familiar ******** */
    async getAllAlumnosFamilia() {
      try {
        let params = {
          id_colegio: sessionStorage.id_colegio,
          id_persona: sessionStorage.id_persona,
          id_anio_lectivo: sessionStorage.id_ano_lectivo,
        };
        const response = await axios.post("/academico/padre/all/alu/", params);
        this.AlumnosFam = response.data;
      } catch (error) {
        console.log(error);
      }
    },

    //// metodo para listar las areas //////////
    async getAllAreasFamilia(alumno) {
      this.paramsTareas.id_alumno = alumno.id_alumno;
      this.NivelAlumno = alumno.desc_nivel;
      this.GradoAlumno = alumno.desc_grado;
      this.SeccionAlumno = alumno.nombre_seccion;
      try {
        const response = await axios.post(
          "/academico/padre/all/alu/ars/",
          this.paramsTareas
        );
        this.AreaFam = response.data;
        this.inhabilitarAreaFam = false;
        this.getAllActividades("alumno");
      } catch (error) {
        console.log(error);
      }
    },
    ///// metodo para listar los Cursos //////
    async getAllCursosFamilia(nivel) {
      this.paramsTareas.id_area = nivel.id;
      this.paramsTareas.id_curso = null;
      this.inhabilitarPeriodo = false;
      this.elrango = "";
      this.CursoFam = [];
      try {
        const response = await axios.post(
          "/academico/padre/all/alu/curs/",
          this.paramsTareas
        );
        this.CursoFam = response.data;
        this.inhabilitarCursoFam = false;
        this.getAllPeriodoFamilia(nivel.id_nivel);
      } catch (error) {
        console.log(error);
      }
    },
    //**********  cargar los periodos  **** ******/
    async getAllPeriodoFamilia(id_nivel) {
      try {
        let params = {
          id_colegio: sessionStorage.id_colegio,
          id_ano_lectivo: sessionStorage.id_ano_lectivo,
          id_nivel: id_nivel,
        };
        const response = await axios.post(
          "/academico/coordinador/act/alu/pdo/",
          params
        );
        this.PeriodoFam = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    //******  cargar todas las actividades  de los alumnos  *****/
    async getAllActividades(tipo) {
      if (tipo === "curso") {
        this.inhabilitarPeriodo = false;
      }
      try {
        const response = await axios.post(
          "/academico/padre/all/alu/act/",
          this.paramsTareas
        );
        this.ActividadesFamilia = response.data;
        if (this.ActividadesFamilia.length > 0) {
          this.botonCalendario = true;
          this.botonReporte = true;
        } else {
          this.botonCalendario = false;
          this.botonReporte = false;
        }
        this.reporte(this.ActividadesFamilia);
      } catch (error) {
        console.log(error);
      }
    },
    // botos para visualizar clases de la programacion de contenido
    async visualizarClase(id_clase) {
      try {
        let response = await axios.get(
          "/administrativo/contenido/list/" + id_clase + ""
        );

        //let response = await axios.get("/administrativo/contenido/"+id_clase+"");
        this.api_list_contenidos = response.data;

        this.tipoVisor = "ModalVisorColegio";
        this.visor = true;
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error: ${error}`,
          tiempo: null,
        });
        //console.log(error)
      }
    },
    //*****obtener los rangos para agregar fechas  */
    async obtenerRangos() {
      try {
        var fechaInicio = this.elrango.substr(0, 10);
        var fechaFin = this.elrango.substr(11, 22);
        this.paramsTareas.fecha_inicio = fechaInicio;
        this.paramsTareas.fecha_fin = fechaFin;
        // console.log('Las parametros:------>>>'+JSON.stringify(this.paramsClases))
        await this.getAllActividades("periodo");
      } catch (error) {
        console.log(error);
      }
    },
    //  reporte
    reporte(item) {
      var creadas = 0;
      var recibidas = 0;
      var evaluadas = 0;
      var porevaluar = 0;
      //this.modal_reporte = true
      for (var i = 0; i < item.length; i++) {
        switch (item[i].id_estado_actividad_alumno) {
          case 1: // generado
            creadas = creadas + 1;
            break;
          case 2: // por evaluar
            porevaluar = porevaluar + 1;
            break;
          case 4: // enviado
            recibidas = recibidas + 1;
            break;
          case 3: // evaluada
            evaluadas = evaluadas + 1;
            break;
          default:
            break;
        }
      }
      //var ejecutada = creadas*100/item.length;
      this.contEjecutada = creadas;
      //var programada  = recibidas*100/item.length;
      this.contProgramada = recibidas;
      // var repro = evaluadas*100/item.length;
      this.contReprogramada = evaluadas;
      //var sineje = porevaluar*100/item.length;
      this.contSinejecutar = porevaluar;
    },
    closeModalReporte() {
      this.modal_reporte = false;
      this.contSinejecutar = 0;
      this.contEjecutada = 0;
      this.contProgramada = 0;
      this.contReprogramada = 0;
      this.contActualizada = 0;
    },

    ////////////////////--------FIN NUEVAS FUNCIONES -----------//////////////////

    async verSeguimiento(id) {
      this.modal_seguimiento = true;

      let response = await axios.get(
        "/academico/progDocente/getSeguimiento/" + id
      );
      this.seguimientoClase = response.data.payload.Seguimiento;
    },

    // funcion para cerrar modal
    cerrarVisor() {
      this.visor = false;
      this.api_list_contenidos = [];
      this.tipoVisor = "";
      //this.setCloseVisor()
    },

    // SE MODIFICO PARA QUE CONSUMIERA LA INFORMACIÓN DEL SPACE EN LUGAR DEL DROPLET
    async download(url) {
      console.log(url);
      await this.$Files["downloadFetch"]({ url });
    },


    // reset filtros

    resetearFiltros(){
      this.alumno = null
      this.NivelA = ""
      this.paramsTareas.id_curso = null,
      this.elrango = ""


      this.paramsTareas.id_area = null
      this.paramsTareas.id_alumno = null
      this.paramsTareas.fecha_inicio = null
      this.paramsTareas.fecha_fin = null

      this.NivelAlumno = "";
      this.GradoAlumno = "";
      this.SeccionAlumno = "";

      this.ActividadesFamilia = [];
      this.AreaFam = [];
      this.CursoFam = [];
      this.PeriodoFam = [];
      this.inhabilitarAreaFam = true
      this.inhabilitarCursoFam = true
      this.inhabilitarPeriodo = true

      
    }
  },
};
</script>
<style scoped>
.barra {
  height: 300px;
  position: relative;
  width: 100%;
  justify-content: center;
  align-content: center;
  display: flex;
  margin-top: 25px;
}
.programada {
  background: #ffbe33;
  width: 25%;
  bottom: 0px;
  position: absolute;
  left: 0;
}
.ejecutada {
  background: red;
  width: 25%;
  bottom: 0px;
  position: absolute;
  left: 25%;
}
.sin-ejecutar {
  background: green;
  width: 25%;
  bottom: 0px;
  position: absolute;
  left: 50%;
}
.reprogramada {
  background: blue;
  width: 25%;
  bottom: 0px;
  position: absolute;
  left: 75%;
}
.actualizada {
  background: rgb(241, 80, 6);
  width: 20%;
  bottom: 0px;
  position: absolute;
  right: 0;
}
.programada h2 {
  position: absolute;
  left: 33%;
  font-size: 20px;
  bottom: 8px;
}
.ejecutada h2 {
  position: absolute;
  bottom: 8px;
  left: 33%;
  font-size: 20px;
  text-align: center;
}
.sin-ejecutar h2 {
  position: absolute;
  bottom: 8px;
  left: 33%;
  font-size: 20px;
}
.reprogramada h2 {
  position: absolute;
  bottom: 8px;
  left: 33%;
  font-size: 20px;
}
.actualizada h2 {
  position: absolute;
  bottom: 8px;
  left: 33%;
  font-size: 20px;
}
#programada {
  position: absolute;
  left: 10%;
  font-size: 16px;
  color: #ffbe33;
  bottom: 14%;
}
#ejecutada {
  position: absolute;
  color: red;
  font-size: 16px;
  left: 33%;
  bottom: 14%;
}
#reprogramada {
  font-size: 16px;
  position: absolute;
  color: green;
  left: 56%;
  bottom: 14%;
}
#sin-ejecutar {
  position: absolute;
  font-size: 15px;
  bottom: 14%;
  left: 80%;
  color: blue;
}
#actualizada {
  position: absolute;
  right: 7%;
  color: orangered;
  bottom: 14%;
  font-size: 15px;
}
.nivel,
.grado,
.seccion {
  width: 100%;
  height: 50px;
  position: relative;
  border-bottom: 1px solid #1565c0;
}

.nivel span {
  position: absolute;
  top: 23px;
  text-transform: UPPERCASE;
}

.seccion span {
  position: absolute;
  top: 23px;
  text-transform: UPPERCASE;
}
@media (max-width: 425px) {
  .seccion {
    margin-bottom: 16px;
  }
}

.grado span {
  position: absolute;
  top: 23px;
  text-transform: UPPERCASE;
}
.nivel p {
  font-size: 13px;
}
.grado p {
  font-size: 13px;
}
.seccion p {
  font-size: 13px;
}

#container {
  margin-bottom: 100px;
}
.card-alumnos {
  width: 100%;
  height: auto;
  background: #fff;
  border: 1px solid #b7babb;
  border-radius: 10px;
  padding: 5px;
  box-shadow: 0px 2px 9px 3px #b7babb;
  padding-bottom: 5px;
}
.title-alumnos {
  width: 100%;
  height: 20px;
  background: #0c67b8;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.alumno {
  width: 100%;
  padding-top: 9px;
  padding-left: 8px;
}
.title-alumnos h5 {
  color: #fff;
  text-transform: uppercase;
  text-align: center;
}
.sin-alumnos {
  width: 100%;
  height: 30px;
  background: #facc1e;
  text-align: center;
  margin-top: 5px;
  color: #fff;
  font-weight: bold;
  border-radius: 5px;
}
</style>
